import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Podróżowanie na nowo",
      subtitle: "Etyczna, lokalna i ludzka wizja turystyki jutra.",
    },
    mission: {
      badge: "Nasza Misja",
      title: "Uczciwa turystyka",
      description:
        "Wierzymy, że podróżowanie powinno być dostępne dla wszystkich, bez drogich pośredników. DONKEY TRAVEL umożliwia właścicielom swobodne podróżowanie dzięki wartości ich własnej nieruchomości.",
    },
    philosophy: {
      badge: "Nasza Filozofia",
      title: "Stworzone we Francji i ludzkie",
      description:
        "Zakorzenieni w Dolinie Sommy, bronimy rzemieślniczego modelu przed gigantami technologicznymi. Żadnych nieprzejrzystych algorytmów, tylko zdrowy rozsądek i przyjazna atmosfera.",
      values: {
        fair: {
          title: "Uczciwy",
          desc: "0% prowizji od wymian. Tylko przejrzysta subskrypcja.",
        },
        local: {
          title: "Lokalne Zakorzenienie",
          desc: "Dumni z naszych francuskich korzeni, promujemy turystykę szanującą miejsca.",
        },
        community: {
          title: "Wspólnotowy",
          desc: "Prywatny klub zaufanych właścicieli, którzy podzielają te same wartości.",
        },
      },
    },
    team: {
      badge: "Zespół",
      title: "Pasjonaci w Twoiej służbie",
      subtitle:
        "Za platformą stoją ludzie, którzy kochają podróżować i dzielić się.",
      members: {
        ceo: {
          name: "Plük",
          role: "Twórca DONKEY TRAVEL • Deweloper • Airbnb Superhost od 4 lat",
          bio: "Przez lata gościłem podróżnych w moich domach, do których sam mógłbym pojechać, gdyby istniał TRAVELTROK. Dlatego stworzyłem DONKEY TRAVEL: aby umożliwić gospodarzom wzajemne goszczenie się i podróżowanie w inny sposób.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Architektka platformy, strażniczka bezpieczeństwa.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Kierownik ds. Komunikacji",
          bio: "Głos DONKEY TRAVEL dla naszej społeczności.",
        },
      },
    },
    investors: {
      badge: "Inwestorzy",
      title: "Dołącz do przygody",
      description:
        "DONKEY TRAVEL jest w pełnym rozkwicie. Szukamy partnerów, którzy podzielają naszą wizję zrównoważonej i sprawiedliwej turystyki.",
      cta: "Skontaktuj się z nami w sprawie inwestycji",
    },
  },
  trokOrigin: {
    badge: "Zrozumieć koncepcję",
    title: "Wymiana, co to dokładnie jest?",
    subtitle:
      "Bezpośrednia wymiana między dwiema osobami, bez pośredników i skomplikowanego systemu punktów",
    etymology: {
      title: "Pochodzenie słowa",
      historicalTitle: "Starożytna praktyka",
      text1:
        'Słowo "Troc" pojawia się w języku francuskim w XIV wieku, wywodząc się od czasownika "troquer". Ma swoje korzenie w hiszpańskim "trucque" i walońskim "trouk", przywołując ideę bezpośredniej wymiany.',
      text2:
        'Potwierdzone już w 1364 roku w formie "truke" w dokumentach anglo-normańskich, a następnie oficjalnie w 1464 roku w listach patentowych Ludwika XI: "do sprzedaży, troc lub wymiany tych towarów".',
      text3:
        "W DONKEY TRAVEL zachowaliśmy tę starożytną filozofię: wymieniasz bezpośrednio swoje mieszkanie z innym właścicielem. Żadnej wirtualnej waluty, żadnych punktów do zbierania. Tylko umowa między dwiema osobami.",
      from: "Etymologia",
      meaning: "Wymieniać bezpośrednio, osoba z osobą",
      century14: "XIV wiek",
      firstAttestation: "Pierwsze poświadczenie w języku francuskim",
      century15: "XV wiek",
      officialUse: "Oficjalne użycie przez Ludwika XI",
      today: "Dziś",
      modernPractice: "Nowoczesna i wspólna praktyka",
    },
    direct: {
      title: "Tylko bezpośrednia wymiana",
      description:
        "W przeciwieństwie do systemów punktowych lub kredytowych, DONKEY TRAVEL działa na zasadzie czystego barteru. Negocjujesz bezpośrednio z innym właścicielem: Twoje noce za jego. To esencja wymiany barterowej, jaka istnieje od XIV wieku.",
      result: "Bezpośrednia wymiana zatwierdzona!",
    },
    noTriangulation: {
      title: "Brak triangulacji",
      description:
        "Żadnego skomplikowanego systemu, gdzie A daje B, który daje C. Tutaj jest prosto: znajdujesz kogoś, negocjujecie razem (daty jednoczesne lub przesunięte), wymieniacie się. Kropka.",
      noPoints: "Brak punktów do liczenia",
    },
    meetHost: {
      title: "Poznaj innego gospodarza Airbnb",
      description:
        "DONKEY TRAVEL to nie tylko odkrywanie mieszkania czy podróżowanie. To przede wszystkim spotkanie z innym pasjonatem gościnności, kimś, kto podziela Twoje wartości. Wymiana była zawsze praktyką społeczną, zanim stała się ekonomiczną.",
      share: "Podziel się swoimi doświadczeniami",
      tips: "Wymień się najlepszymi wskazówkami",
      friendship: "Stwórz trwałe przyjaźnie",
      badge: "Społeczność gospodarzy",
      badgeSub: "Autentyczne spotkania",
      step2Title: "2. Umowa polubowna na DONKEY TRAVEL",
      step2Desc:
        "Podpisują umowę wymiany bezpośrednio na platformie i otrzymują PDF e-mailem. Wszystko jest bezpieczne i oficjalne.",
      contractSigned: "Umowa podpisana i bezpieczna",
      step3Title: "3. Maria przyjeżdża do Paryża (2 tygodnie później)",
      step3Desc:
        "Jean wita Marię ciepło. Jest pod wrażeniem: mieszkanie jest nieskazitelne, Maria szanuje wszystko. Co za różnica w porównaniu z niektórymi podróżnymi Airbnb! Rozmawiają o swoich doświadczeniach gospodarzy przy kawie.",
      step4Title: "4. Jean odkrywa Reims (6 miesięcy później)",
      step4Desc:
        "Jean przyjeżdża do domku Marii w Reims. Otoczenie jest wspaniałe! Maria zaprasza go na kolację, jedzą razem i naprawiają świat, rozmawiając o podróżach, Airbnb i ich najlepszych anegdotach gospodarzy.",
      step5Title: "5. Trwała przyjaźń",
      step5Desc:
        "Maria i Jean pozostają w kontakcie. Decydują się regularnie wymieniać swoimi mieszkaniami. Więcej niż prosta wymiana, to prawdziwa przyjaźń narodzona dzięki TRAVELTROK.",
      spiritTitle: "Oto duch DONKEY TRAVEL!",
      spiritDesc:
        "Autentyczne wymiany między pasjonatami właścicielami, w szacunku i przyjaznej atmosferze. Bez punktów, bez triangulacji, tylko prawdziwy barter w starym stylu.",
    },
    negotiation: {
      badge: "Zabawna negocjacja",
      title: "Negocjuj jak w grze!",
      description:
        "10 nocy za 5? Czemu nie! Złóż ofertę, otrzymaj kontrofertę, znajdź porozumienie. Wszystko w dobrej atmosferze. Jak w czasach pierwszych wymian, negocjacja jest częścią przyjemności.",
      marieProperty: "Domek w Reims",
      jeanProperty: "Mieszkanie w Paryżu",
      marieLocation: "W swoim domku w Reims",
      jeanLocation: "W swoim mieszkaniu w Paryżu",
      marieAccepts: "Maria akceptuje ofertę",
      offers: "Oferta",
      proposes: "Proponuje",
      nights: "nocy",
      status: {
        initial: "Maria składa ofertę...",
        counter: "Jean składa kontrofertę!",
        negotiate: "Maria negocjuje...",
        deal: "Umowa zawarta! 🎉",
      },
      chat: {
        msg1: "Proponuję Ci {{marieNights}} nocy w moim domku w Reims za {{jeanNights}} nocy w Paryżu!",
        msg2: "Jean uważa mieszkanie Marii za bardzo dobre...",
        msg3: "Twój domek jest wspaniały! Jestem miły, proponuję Ci {{jeanNights}} nocy w Paryżu 😊",
        msg4: "Umowa stoi! 🤝",
        msg5: "Maria sprawdza dostępność Jeana...",
      },
      nextStep: "Następny krok",
      restart: "Zacznij od nowa",
      points: {
        flexible: "Elastyczna negocjacja",
        friendly: "Przyjazna atmosfera",
        fair: "Uczciwa umowa",
      },
    },
    flexibility: {
      title: "Pełna elastyczność",
      description:
        "W przeciwieństwie do tradycyjnych wymian, nie musisz znajdować kogoś, kto chce Twojego mieszkania dokładnie wtedy, gdy Ty chcesz jego. Zbieraj Troki i używaj ich, kiedy Ci pasuje!",
    },
    example: {
      person1: "Maria",
      location1: "Paryż, Francja",
      person2: "Jean",
      location2: "Lyon, Francja",
      result: "Wymiana udana!",
    },
  },
  exchange: {
    title: "Jak to działa?",
    subtitle: "Prosty i bezpieczny system wymiany domów z pełnym zaufaniem",
    features: {
      secure: {
        title: "Bezpieczne wymiany",
        description:
          "Wszyscy członkowie są zweryfikowani, a opinie gwarantują przejrzystość każdej wymiany.",
      },
      sync: {
        title: "Synchronizacja kalendarza",
        description:
          "Automatycznie synchronizuj swoje dostępności z istniejącym kalendarzem Airbnb.",
      },
      global: {
        title: "Europejska sieć",
        description:
          "Uzyskaj dostęp do gospodarzy w krajach europejskich dostępnych na TRAVELTROK.",
      },
      chat: {
        title: "Wbudowany komunikator",
        description:
          "Komunikuj się bezpośrednio z innymi właścicielami, aby organizować wymiany.",
      },
      rating: {
        title: "System ocen",
        description:
          "Sprawdź opinie i oceny, aby wybrać partnerów wymiany z pełnym zaufaniem.",
      },
      savings: {
        title: "Gwarantowane oszczędności",
        description:
          "Podróżuj za darmo, używając Wymianaów zamiast płacić za drogie noclegi.",
      },
    },
    steps: {
      title: "W 3 prostych krokach",
      step1: {
        title: "Utwórz swój profil",
        description:
          "Zarejestruj się i dodaj informacje o swoim mieszkaniu Airbnb w kilka minut.",
      },
      step2: {
        title: "Znajdź cel podróży",
        description: "Przeglądaj dostępne domy i znajdź cel swoich marzeń.",
      },
      step3: {
        title: "Wymień się i podróżuj",
        description:
          "Zaproponuj wymianę, potwierdź daty i ciesz się pobytem za darmo!",
      },
    },
  },
  worldMap: {
    title: "Top 20 najaktywniejszych krajów",
    subtitle: "Odkryj kraje, gdzie wymiany domów są dziś najpopularniejsze",
    description:
      "Nasza społeczność rośnie każdego dnia z nowymi właścicielami na całym świecie. Sprawdź, gdzie możesz podróżować za darmo.",
    badge: "Ranking w czasie rzeczywistym",
    properties: "domy",
    cta: "Zobacz wszystkie miejsca docelowe",
    exchangesToday: "Wymiany dzisiaj",
    activeCountries: "Aktywne kraje",
    vsYesterday: "vs. wczoraj",
    fullRanking: "Pełny ranking",
    countries: {
      Guadeloupe: "Gwadelupa",
      Martinique: "Martynika",
      Guyane: "Gujana Francuska",
      "La Réunion": "Reunion",
      Mayotte: "Majotta",
      "Polynésie française": "Polinezja Francuska",
      "Nouvelle-Calédonie": "Nowa Kaledonia",
      "Îles Canaries": "Wyspy Kanaryjskie",
      "Ceuta & Melilla": "Ceuta i Melilla",
      Madère: "Madera",
      Açores: "Azory",
      Aruba: "Aruba",
      Curaçao: "Curaçao",
      "Saint-Martin": "Sint Maarten",
      Bermudes: "Bermudy",
      "Îles Caïmans": "Kajmany",
      Gibraltar: "Gibraltar",
      france: "Francja",
      spain: "Hiszpania",
      italy: "Włochy",
      usa: "Stany Zjednoczone",
      uk: "Wielka Brytania",
      germany: "Niemcy",
      portugal: "Portugalia",
      netherlands: "Holandia",
      canada: "Kanada",
      australia: "Australia",
      belgium: "Belgia",
      switzerland: "Szwajcaria",
      greece: "Grecja",
      mexico: "Meksyk",
      brazil: "Brazylia",
      austria: "Austria",
      croatia: "Chorwacja",
      thailand: "Tajlandia",
      morocco: "Maroko",
    },
  },
  calendar: {
    title: "Automatyczna synchronizacja z Airbnb",
    subtitle: "Połącz swój kalendarz Airbnb jednym kliknięciem",
    description:
      "Twoje dostępności synchronizują się automatycznie. Nie musisz już zarządzać dwoma kalendarzami osobno.",
    features: {
      sync: {
        title: "Dwukierunkowa synchronizacja",
        description:
          "Twoje kalendarze Airbnb i DONKEY TRAVEL są zawsze aktualne automatycznie",
      },
      realtime: {
        title: "Aktualizacje w czasie rzeczywistym",
        description:
          "Każda zmiana jest natychmiast synchronizowana na obu platformach",
      },
      smart: {
        title: "Inteligentne zarządzanie",
        description:
          "Unikaj podwójnych rezerwacji dzięki naszemu zaawansowanemu systemowi synchronizacji",
      },
    },
    cta: "Połącz mój kalendarz",
  },
  airbnb: {
    title: "Jesteś już gospodarzem Airbnb?",
    subtitle: "Dołącz do DONKEY TRAVEL i zacznij podróżować za darmo",
    description:
      "Zaimportuj automatycznie informacje o swoim mieszkaniu Airbnb i zacznij wymieniać się już dziś.",
    features: {
      verification: {
        title: "Automatyczna weryfikacja Twojego profilu",
      },
      import: {
        title: "Import Twoich zdjęć i opisów",
      },
      trust: {
        title: "Dołącz do zaufanej społeczności",
      },
    },
    cta: "Połącz mój Airbnb",
  },
  membersMap: {
    title: "Mapa członków",
    searchPlaceholder: "Szukaj miejsca docelowego, miasta...",
    filters: "Filtry",
    radius: "Promień",
    radiusAuto: "Automatycznie",
    reset: "Resetuj",
    filterPets: "Zwierzęta akceptowane",
    filterVerified: "Zweryfikowani gospodarze",
    filterRating: "4.8+",
    filterAllTypes: "Wszystkie typy",
    oneTraveler: "1 podróżny",
    multipleTravelers: "{{count}} podróżnych",
    dates: "Daty",
    addDates: "Dodaj daty",
    startDate: "Wyjazd",
    endDate: "Powrót",
    listingsTitle: "Domy",
    listingsSubtitle: "Wybierz, aby zobaczyć na mapie.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Wyczyść filtry",
    guestsShort: "os.",
    bedroomsShort: "syp.",
    surfaceAreaUnit: "m²",
    perNight: "/ noc",
    online: "Połączony",
    offline: "Niepołączony",
    verified: "Zweryfikowany",
    favorite: "Ulubiony",
    favorites: "Ulubione",
    members: "Członkowie",
    exchanges: "wymiany",
    rooms: "pokoje",
    mapTitle: "Interaktywna mapa członków DONKEY TRAVEL",
    countries: "Kraje",
    results: "wyniki",
    viewProfile: "Zobacz profil",
    proposeExchange: "Zaproponuj wymianę",
    showFavoritesOnly: "Pokaż tylko ulubione",
    advancedSearch: "Wyszukiwanie zaawansowane",
    refineSearch: "Doprecyzuj wyszukiwanie",
    activeFilter: "aktywny filtr",
    activeFilters: "aktywne filtry",
    availabilityDates: "Daty dostępności",
    quickPeriods: "Szybkie okresy",
    thisMonth: "Ten miesiąc",
    nextMonth: "Przyszły miesiąc",
    next3Months: "Następne 3 miesiące",
    summer: "Lato",
    autumn: "Jesień",
    winter: "Zima",
    arrival: "Przyjazd",
    departure: "Wyjazd",
    flexibleDates: "Elastyczne daty",
    clear: "Wyczyść",
    propertyTypeTitle: "Typ nieruchomości",
    apartment: "Mieszkanie",
    house: "Dom",
    villa: "Willa",
    loft: "Loft",
    capacityAndRooms: "Pojemność i pokoje",
    numberOfTravelers: "Liczba podróżnych",
    all: "Wszystkie",
    numberOfRooms: "Liczba pokoi",
    minimumSurface: "Minimalna powierzchnia",
    equipments: "Udogodnienia",
    wifi: "Wi-Fi",
    pool: "Basen",
    parking: "Parking",
    airConditioning: "Klimatyzacja",
    garden: "Ogród",
    terrace: "Taras",
    fireplace: "Kominek",
    barbecue: "Grill",
    bike: "Rower",
    sauna: "Sauna",
    gym: "Siłownia",
    washingMachine: "Pralka",
    statusAvailability: "Status i dostępność",
    onlineAvailability: "Dostępność w czasie rzeczywistym",
    onlineOnly: "Tylko połączone",
    verifiedMembersOnly: "Tylko zweryfikowani członkowie",
    ratingExperience: "Ocena i doświadczenie",
    minimumRating: "Minimalna ocena",
    minimumExchanges: "Minimalna liczba wymian",
    matchingMembers: "pasujący członkowie",
    matchingMember: "pasujący członek",
    seeResults: "Zobacz",
    result: "wynik",
    resetAllFilters: "Zresetuj wszystkie filtry",
    rating: "Ocena",
    travelers: "Podróżni",
    contact: "Kontakt",
    searchMemberCity: "Szukaj członka, miasta, kraju...",
    noFavorite: "Brak ulubionych",
    addFavoritesHint: "Dodaj członków do ulubionych, klikając serce",
    noMemberFound: "Nie znaleziono członka",
    tryModifyFilters: "Spróbuj zmienić filtry",
    viewAllMembers: "Zobacz wszystkich członków",
    modifyFilters: "Zmień filtry",
    favoritesOnly: "Tylko ulubione",
    addToFavorites: "Dodaj do ulubionych",
    removeFromFavorites: "Usuń z ulubionych",
    loading: "Ładowanie...",
    sortBy: "Sortuj według",
    relevance: "Trafność",
    newest: "Najnowsze",
    noResults: "Brak wyników",
    tryDifferentFilters: "Spróbuj dostosować filtry wyszukiwania",
    membersList: "Lista członków",
    membersFound: "znalezionych członków",
    visibleMembers: "Widoczni członkowie",
    legend: "Legenda",
    availableProperty: "Dostępny dom",
    selected: "Wybrany",
    visibleByAll: "Widoczny dla wszystkich",
    allMembersSeeYou: "Wszyscy członkowie Cię widzą",
    targetedMode: "Tryb celowany",
    countriesSelected: "wybrane kraje",
    countrySelected: "wybrany kraj",
    myVisibility: "Moja widoczność",
    whoCanSee: "Kto widzi mój dom na mapie?",
    visibleByAllTitle: "Widoczny dla wszystkich",
    visibleByAllDesc:
      "Wszyscy członkowie społeczności mogą zobaczyć Twój dom i zaproponować wymianę.",
    visibleByAllHint: "Maksymalna widoczność i możliwości",
    active: "AKTYWNY",
    targetedModeTitle: "Tryb celowany",
    targetedModeDesc:
      "Tylko członkowie z krajów, których szukasz, mogą zobaczyć Twój dom. Maksymalna dyskrecja.",
    targetedModeHint: "Widzisz i jesteś widziany tylko przez swoje cele",
    myDesiredDestinations: "Moje pożądane miejsca docelowe",
    clearAll: "Wyczyść wszystko",
    searchCountry: "Szukaj kraju...",
    member: "członek",
    membersCount: "członków",
    noCountryFound: "Nie znaleziono kraju",
    targetedInfoTitle: "Twój dom pojawi się tylko dla członków w",
    targetedInfoDesc: "Inni nie zobaczą Cię na mapie.",
    targetedExample:
      "Przykład: jeśli chcesz jechać tylko do Holandii, tylko holenderscy członkowie zobaczą Twój profil.",
    selectAtLeastOneCountry:
      "Wybierz przynajmniej jeden kraj, aby aktywować tryb celowany.",
    propertyTypes: {
      appartement: "Mieszkanie",
      maison: "Dom",
      villa: "Willa",
      loft: "Loft",
      luxe: "Luksus",
      insolite: "Nietypowe",
    },
    pricePerNight: "CENA ZA NOC (€)",
    min: "Min",
    max: "Maks",
    sortResults: "SORTOWANIE WYNIKÓW",
    sort: {
      recommended: "✨ Polecane",
      priceAsc: "💶 Cena rosnąco",
      priceDesc: "💎 Cena malejąco",
    },
    amenitiesTitle: "UDOGODNIENIA",
    amenitiesTabs: {
      all: "WSZYSTKIE",
      essentials: "PODSTAWOWE",
      features: "KOMFORT",
      location: "LOKALIZACJA",
      safety: "BEZPIECZEŃSTWO",
    },
  },
  amenities: {
    wifi: "Wi-Fi",
    tv: "Telewizja",
    kitchen: "Kuchnia",
    washing_machine: "Pralka",
    ac: "Klimatyzacja",
    heating: "Ogrzewanie",
    workspace: "Miejsce do pracy",
    iron: "Żelazko",
    hair_dryer: "Suszarka do włosów",
    pool: "Basen",
    hottub: "Jacuzzi",
    patio: "Taras",
    bbq: "Grill",
    parking: "Darmowy parking",
    gym: "Siłownia",
    fireplace: "Kominek",
    breakfast: "Śniadanie",
    beachfront: "Przy plaży",
    ski_in_out: "Przy stoku",
    lake_access: "Dostęp do jeziora",
    smoke_detector: "Czujnik dymu",
    first_aid: "Apteczka",
    fire_extinguisher: "Gaśnica",
  },
  destinations: {
    title: "Miejsca docelowe",
    searchPlaceholder: "Szukaj miejsca docelowego...",
    destinationsFound: "znalezionych miejsc docelowych",
    noResults: "Brak wyników",
    tryDifferentSearch: "Spróbuj innego wyszukiwania",
    sortMembers: "Najwięcej członków",
    sortProperties: "Najwięcej domów",
    sortName: "Nazwa (A-Z)",
    all: "Wszystkie",
    members: "członków",
    properties: "domów",
    explore: "Odkryj to miejsce",
    stats: {
      destinations: "Miejsca docelowe",
      members: "Członkowie",
      properties: "Domy",
      countries: "Kraje",
    },
    countriesIn: "Kraje w",
    selectCountry: "— wybierz kraj, aby filtrować",
    continents: {
      Europe: "Europa",
      "Amérique du Nord": "Ameryka Północna",
      "Amérique du Sud": "Ameryka Południowa",
      Asie: "Azja",
      Afrique: "Afryka",
      Océanie: "Oceania",
    },
    countries: {
      Turquie: "Turcja",
      France: "Francja",
      "Pays-Bas": "Holandia",
      "Royaume-Uni": "Wielka Brytania",
      Espagne: "Hiszpania",
      Italie: "Włochy",
      Tchéquie: "Czechy",
      Grèce: "Grecja",
      Portugal: "Portugalia",
      Autriche: "Austria",
      Écosse: "Szkocja",
      Hongrie: "Węgry",
      Croatie: "Chorwacja",
      Danemark: "Dania",
      Suède: "Szwecja",
      Suisse: "Szwajcaria",
      Belgique: "Belgia",
      Norvège: "Norwegia",
      Irlande: "Irlandia",
      Pologne: "Polska",
      Finlande: "Finlandia",
      Islande: "Islandia",
      Roumanie: "Rumunia",
      Monténégro: "Czarnogóra",
      "États-Unis": "Stany Zjednoczone",
      Canada: "Kanada",
      Mexique: "Meksyk",
      "Costa Rica": "Kostaryka",
      Cuba: "Kuba",
      "Rép. Dominicaine": "Dominikana",
      Guatemala: "Gwatemala",
      Brésil: "Brazylia",
      Argentine: "Argentyna",
      Pérou: "Peru",
      Colombie: "Kolumbia",
      Chili: "Chile",
      Équateur: "Ekwador",
      Uruguay: "Urugwaj",
      Bolivie: "Boliwia",
      Chine: "Chiny",
      Thaïlande: "Tajlandia",
      Indonésie: "Indonezja",
      Vietnam: "Wietnam",
      "Corée du Sud": "Korea Południowa",
      Inde: "Indie",
      Cambodge: "Kambodża",
      Jordanie: "Jordania",
      Maldives: "Malediwy",
      "Sri Lanka": "Sri Lanka",
      Népal: "Nepal",
      Philippines: "Filipiny",
      Ouzbékistan: "Uzbekistan",
      Égypte: "Egipt",
      Maroc: "Maroko",
      "Afrique du Sud": "RPA",
      Tanzanie: "Tanzania",
      Kenya: "Kenia",
      Sénégal: "Senegal",
      Madagascar: "Madagaskar",
      Tunisie: "Tunezja",
      Zimbabwe: "Zimbabwe",
      Namibie: "Namibia",
      "Île Maurice": "Mauritius",
      Rwanda: "Rwanda",
      Australie: "Australia",
      "Nouvelle-Zélande": "Nowa Zelandia",
      "Polynésie française": "Polinezja Francuska",
      Fidji: "Fidżi",
      "Nouvelle-Calédonie": "Nowa Kaledonia",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "Paryż",
      "Mont Saint-Michel": "Mont Saint-Michel",
      Marseille: "Marsylia",
      Amsterdam: "Amsterdam",
      Londres: "Londyn",
      Barcelone: "Barcelona",
      Madrid: "Madryt",
      Venise: "Wenecja",
      Rome: "Rzym",
      "Côte Amalfitaine": "Wybrzeże Amalfitańskie",
      Prague: "Praga",
      Santorin: "Santorini",
      Athènes: "Ateny",
      Lisbonne: "Lizbona",
      Porto: "Porto",
      Vienne: "Wiedeń",
      Édimbourg: "Edynburg",
      Budapest: "Budapeszt",
      Dubrovnik: "Dubrownik",
      Copenhague: "Kopenhaga",
      Stockholm: "Sztokholm",
      Zermatt: "Zermatt",
      Bruges: "Brugia",
      Bergen: "Bergen",
      Dublin: "Dublin",
      Cracovie: "Kraków",
      Helsinki: "Helsinki",
      Reykjavik: "Reykjavik",
      Bucarest: "Bukareszt",
      Kotor: "Kotor",
      "New York": "Nowy Jork",
      "San Francisco": "San Francisco",
      "Los Angeles": "Los Angeles",
      Miami: "Miami",
      Hawaï: "Hawaje",
      Vancouver: "Vancouver",
      Montréal: "Montreal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Quebec",
      Cancún: "Cancún",
      "Mexico City": "Meksyk",
      "San José": "San José",
      "La Havane": "Hawana",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Rio de Janeiro",
      "São Paulo": "São Paulo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Cartagena",
      Bogotá: "Bogota",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevideo",
      "La Paz": "La Paz",
      Tokyo: "Tokio",
      Kyoto: "Kioto",
      Pékin: "Pekin",
      Shanghai: "Szanghaj",
      "Hong Kong": "Hongkong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Ho Chi Minh",
      Séoul: "Seul",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Kolombo",
      Katmandou: "Katmandu",
      Manille: "Manila",
      Samarcande: "Samarkanda",
      Petra: "Petra",
      "Le Caire": "Kair",
      Marrakech: "Marrakesz",
      Chefchaouen: "Szafszawan",
      "Le Cap": "Kapsztad",
      Johannesburg: "Johannesburg",
      Zanzibar: "Zanzibar",
      "Safari Masai Mara": "Safari Masai Mara",
      Nairobi: "Nairobi",
      Dakar: "Dakar",
      Antananarivo: "Antananarywa",
      Tunis: "Tunis",
      "Chutes Victoria": "Wodospady Wiktorii",
      Windhoek: "Windhuk",
      "Île Maurice": "Mauritius",
      Kigali: "Kigali",
      Sydney: "Sydney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Wielka Rafa Koralowa",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Fidżi",
      Nouméa: "Numea",
      Apia: "Apia",
      "Baie d'Halong": "Zatoka Ha Long",
      Maldives: "Malediwy",
    },
  },
  story: {
    badge: "Prawdziwa historia",
    title: "Chloé i Hugo: idealna wymiana",
    subtitle:
      "Kiedy Paryżanka zmęczona miastem spotyka człowieka ze wsi, który marzy o Paryżu...",
    chloé: {
      aptAlt: "Mieszkanie Mayi w Paryżu",
      quotaExceeded: "Limit Airbnb przekroczony!",
      role: "Gospodarz Airbnb w Paryżu",
      speech1:
        'Przekroczyłam <strong class="text-red-600">mój limit 120 nocy</strong>... Niemożliwe wynajmowanie. I szczerze mówiąc, mam dość paryskiego hałasu. 😩',
      nightsTag: "120/120 nocy",
      tiredTag: "Zmęczona Paryżem",
      dreamsOf: "Chloé marzy o...",
      dreamTitle: "Spokój wsi",
      dreamDesc: "Zieleń, cisza, sauna... raj!",
      searching: "Szuka domku na wsi",
      findsLuc: "Znajduje Luca!",
      speech2:
        "W końcu spokój! Sauna po spacerze w lesie to <strong>absolutne szczęście</strong>. 🌿✨",
      review:
        "Domek Luca to mały raj! Sauna po spacerze w lesie to szczęście. Zostaliśmy przyjaciółmi! Polecam w 200%.",
    },
    hugo: {
      giteAlt: "Domek Luca na wsi",
      available: "Dostępny przez cały rok",
      location: "Wieś, Francja",
      role: "Gospodarz Airbnb na wsi",
      speech1:
        'Mój domek ma <strong class="text-sage-600">ogród, saunę i fotel do masażu</strong>... ale nie mogę już wytrzymać na wsi. Marzę o Paryżu! 🗼',
      dreamsOf: "Hugo marzy o...",
      dreamTitle: "Światła Paryża",
      dreamDesc: "Muzea, kawiarnie, Wieża Eiffla... w końcu!",
      searching: "Szuka mieszkania w Paryżu",
      findsMaya: "Znajduje Mayę!",
      speech2:
        "Paryż, w końcu! Luwr, bistra, dachy... to <strong>magiczne</strong>! 🗼🥐",
      review:
        "Mieszkanie Mayi jest niesamowite, widok na dachy Paryża! I to wszystko bez naruszania jej limitu. Wymiana jest genialna!",
    },
    tags: {
      garden: "Ogród",
      sauna: "Sauna",
      massage: "Masaż",
      countryside: "Wieś",
      bigGarden: "Duży ogród",
      restaurants: "Restauracje",
      museums: "Muzea",
    },
    match: {
      spark: "Iskra!",
      title: "Odkrywają DONKEY TRAVEL",
      perfect: "Idealne dopasowanie!",
    },
    quota: {
      title: "Poza limitem Airbnb = 100% za darmo!",
      description:
        "Pobyt Luca nie wpływa na limit Mayi. To wymiana, nie wynajem. Wszyscy wygrywają!",
      totalCost: "Całkowity koszt",
      quotaNight: "Noc limitowa",
    },
    happyEnd: {
      title: "Wszyscy są szczęśliwi! 🎊",
      subtitle:
        "Chloé i Hugo zostali przyjaciółmi. Dzielą się swoimi wskazówkami dla gospodarzy i już planują kolejną wymianę!",
      exchangeSuccess: "Udana wymiana",
      newFriendship: "Nowa przyjaźń",
      outsideQuota: "Poza limitem",
      free: "100% za darmo",
    },
  },
  messaging: {
    messages: "Wiadomości",
    searchPlaceholder: "Szukaj rozmowy...",
    all: "Wszystkie",
    unread: "Nieprzeczytane",
    archived: "Zarchiwizowane",
    online: "Połączony",
    offline: "Niepołączony",
    messagePlaceholder: "Napisz wiadomość...",
    writeMessage: "Napisz wiadomość",
    sending: "Wysyłanie...",
    characters: "znaków",
    noConversation: "Brak rozmowy",
    notificationMessage: "Nowa wiadomość",
    quickActions: "Szybkie akcje",
    proposeExchange: "Zaproponuj wymianę",
    proposeExchangeTitle: "Propozycja wymiany",
    checkAvailability: "Sprawdź dostępność",
    report: "Zgłoś",
    hisProperty: "Jego dom",
    rooms: "pokoje",
    guests: "podróżnych",
    verifiedOwner: "Zweryfikowany właściciel",
    viewAirbnbListing: "Zobacz ogłoszenie Airbnb",
    details: "Szczegóły",
    desiredDates: "Pożądane daty",
    arrival: "Przyjazd",
    departure: "Wyjazd",
    period: "Okres",
    duration: "Czas trwania",
    nights: "nocy",
    numberOfTravelers: "Liczba podróżnych",
    traveler: "podróżny",
    travelers: "podróżnych",
    person: "osoba",
    persons: "osób",
    dateFlexibility: "Elastyczność dat",
    exactDates: "Dokładne daty",
    flex1to2: "± 1-2 dni",
    flex3to5: "± 3-5 dni",
    flexWeek: "± 1 tydzień",
    personalMessage: "Wiadomość osobista",
    summary: "Podsumowanie",
    termsAccept: "Akceptuję warunki wymiany DONKEY TRAVEL",
    sendProposal: "Wyślij propozycję",
    proposalSent: "Propozycja wysłana!",
    proposalSentMessage: "Twoja propozycja została wysłana pomyślnie",
    close: "Zamknij",
    today: "Dziś",
    selectConversation: "Wybierz rozmowę",
    selectConversationHint: "Wybierz właściciela, aby rozpocząć rozmowę",
  },
  destination_introuvable: `Nie znaleziono miejsca docelowego`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `To miejsce docelowe nie istnieje lub zostało przeniesione.`,
  retour_aux_destinations: `Powrót do miejsc docelowych`,
  pr_t___d_couvrir_: `Gotowy do odkrycia`,
  r_server_ce_s_jour: `Zarezerwuj ten pobyt`,
  explorer_d_apos_autres_destinations: `Poznaj inne kierunki`,
  acc_s_r_serv_: `Dostęp zastrzeżony`,
  europe_unique: `Jednolita Europa`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50EUR/rok do wymiany w całej Europie.`,
  lancement_2026: `Uruchomienie 2026`,
  club_d__change_h_tes_airbnb: `Klub wymiany gospodarzy Airbnb`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Zoptymalizuj okresy poza szczytem dzięki giełdom`,
  rejoindre_le_club: `Dołącz do klubu`,
  trouver_un_h_te: `Znajdź gospodarza`,
  r_serv__aux_h_tes_traveltrok: `Zarezerwowane dla gości DONKEY TRAVEL`,
  voyagez_gratuitement_gr_ce___votre_logement: `Podróżuj bezpłatnie z zakwaterowaniem`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Witamy członków i zapraszamy ponownie. Prosta, bezpośrednia i bezgotówkowa wymiana między właścicielami.`,
  devenir_h_te: `Zostań gospodarzem`,
  comment__a_marche__: `Jak to działa?`,
  amis_partageant_un_repas_en_corse: `Przyjaciele jedzący posiłek na Korsyce`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `„Zamieniliśmy nasz dom w Lyonie na willę na Korsyce. Koszt: 0 €.”`,
  sophie___marc__membres_depuis_2023: `Sophie i Marc, członkowie od 2023 r.`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Żadnych monet, żadnych punktów. To tylko umowa pomiędzy dwoma właścicielami. Przychodzę do twojego domu, ty przychodzisz do mojego domu.`,
  "1__accord_mutuel": `1. Wzajemne porozumienie`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Znajdujesz członka, który Ci się podoba i zgadzasz się na wymianę zakwaterowania.`,
  "2__flexibilit__totale": `2. Całkowita elastyczność`,
  "3__z_ro_comptabilit_": `3. Księgowość zerowa`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `Nie ma punktów do zliczenia. Sama przyjemność dzielenia się i spotykania.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Dlaczego gospodarze uwielbiają ten system?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `To więcej niż ekonomia, to nowy sposób podróżowania.`,
  "0__de_frais": `0€ opłat`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Wymiany są całkowicie bezpłatne. Żadnych opłat za usługi, żadnych opłat za sprzątanie (chyba że zostało to wyraźnie uzgodnione).`,
  confiance_totale: `Całkowita pewność`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Tylko zweryfikowani gospodarze mogą handlować. Witamy kogoś, kto zna wartość mieszkania.`,
  simplicit_: `Prostota`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Zapomnij o wartości punktów. Noc jest nocą. Wymiana opiera się na zaufaniu pomiędzy gospodarzami.`,
  rejoignez_la_communaut__des_h_tes: `Dołącz do społeczności gospodarzy`,
  rejoignez_la_communaut__et_commencez____changer_: `Dołącz do społeczności i zacznij rozmawiać.`,
  commencer_maintenant: `Zacznij teraz`,
  pr_nom_invalide: `Nieprawidłowe imię`,
  nom_invalide: `Nieprawidłowa nazwa`,
  email_invalide: `Nieprawidłowy adres e-mail`,
  s_lectionne_un_pays: `Wybierz kraj`,
  s_lectionne_un_mode_tarifaire: `Wybierz metodę wyceny`,
  s_lectionne_ton_usage: `Wybierz zastosowanie`,
  tu_dois_accepter_les_conditions: `Musisz zaakceptować warunki`,
  france: `Francja`,
  belgique: `Belgia`,
  suisse: `Szwajcaria`,
  canada: `Kanada`,
  allemagne: `Niemcy`,
  espagne: `Hiszpania`,
  italie: `Włochy`,
  portugal: `Portugalia`,
  royaume_uni: `Wielka Brytania`,
  _tats_unis: `Stany Zjednoczone`,
  autre: `Inne`,
  merci_de_corriger_les_champs_en_erreur_: `Popraw nieprawidłowe pola.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Wystąpił błąd. Spróbuj ponownie za kilka chwil.`,
  compte_cr___avec_succ_s: `Konto utworzone pomyślnie`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `Otrzymasz wiadomość e-mail umożliwiającą sfinalizowanie profilu podróżnika/gospodarza.`,
  cr_er_un_autre_compte: `Utwórz kolejne konto`,
  activation_traveltrok: `Aktywacja DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Wybierz tryb: podróżny, gospodarz lub mieszany.`,
  pr_nom: `Imię`,
  jeanne: `Jane`,
  nom: `Imię`,
  durand: `Duranda`,
  email: `E-mail`,
  jeanne_email_com: `jeanne@email.com`,
  t_l_phone__optionnel_: `Telefon (opcjonalnie)`,
  pays: `Kraj`,
  choisir_un_pays: `Wybierz kraj`,
  mode_tarifaire: `Metoda wyceny`,
  voyageur: `Podróżnik`,
  nuit: `noc`,
  h_te: `Gospodarz`,
  pro_multi_logements: `Profesjonalna wieloobudowa`,
  mois: `miesiąc`,
  usage_principal: `Główne zastosowanie`,
  je_voyage_principalement: `Głównie podróżuję`,
  je_loue_principalement: `Wynajmuję głównie`,
  je_fais_les_deux: `Robię jedno i drugie`,
  nombre_de_logements: `Liczba miejsc`,
  logement: `zakwaterowanie`,
  logements: `zakwaterowanie`,
  a: `a`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `Akceptuję regulamin i politykę prywatności.`,
  cr_ation_en_cours___: `Tworzenie w toku...`,
  cr_er_mon_compte_traveltrok: `Utwórz moje konto DONKEY TRAVEL`,
  r_servation_de_logements: `Rezerwacja noclegu`,
  support_h_te_prioritaire: `Priorytetowa obsługa hostów`,
  carte___filtres_avanc_s: `Mapa + zaawansowane filtry`,
  flux_de_r_servation__tape_par__tape: `Przebieg rezerwacji krok po kroku`,
  couverture_dommages_assistance: `Ubezpieczenie od szkód/pomocy`,
  multi_logements___reporting: `Wielomieszkaniowość + raportowanie`,
  accueil: `Strona główna`,
  tarifs: `Ceny`,
  "0__commission_pour_les_h_tes": `0% Prowizji dla Gospodarzy`,
  r_volution_traveltrok: `Rewolucja DONKEY TRAVEL`,
  gardez_100__de_ce_que_vous_gagnez: `Zachowaj 100% tego, co zarobisz`,
  simple: `Proste`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `Znasz swój koszt przed dokonaniem rezerwacji. Żadnych niespodzianek przy płatności.`,
  honn_te: `Szczery`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `Ta sama zasada dla wszystkich: podróżny i gospodarz są traktowani na tych samych zasadach.`,
  utile: `Przydatne`,
  je_suis_voyageur: `Jestem podróżnikiem`,
  je_suis_h_te: `Jestem gospodarzem`,
  j_ai_plusieurs_logements: `Mam kilka miejsc noclegowych`,
  simulateur_comparatif_host: `Porównawczy symulator hosta`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Porównaj Booking, Airbnb i DONKEY TRAVEL z własnymi danymi.`,
  nombre_de_nuits: `Liczba nocy`,
  property_price___night__eur_: `Cena nieruchomości / noc (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Inne koszty (sprzątanie, recepcja, pościel itp.) EUR`,
  option___qui_paie_les_frais__5____: `Opcja: Kto płaci opłaty (5%)?`,
  standard__recommand__: `Standardowy (zalecany)`,
  pro___attractivit_: `Pro / Atrakcyjność`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `Podróżny płaci 5% więcej. Otrzymujesz 100% ceny.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `Płacisz 5%. Cena wyświetlana podróżnemu jest ceną netto.`,
  base_de_calcul: `Podstawa obliczenia`,
  nuit_s_: `noc(y)`,
  autres_frais: `Inne koszty`,
  montant_total_avant_commissions: `Całkowita kwota przed prowizjami`,
  plateforme: `Platforma`,
  frais_h_te: `Opłaty dla gospodarzy`,
  frais_voyageur: `Opłaty podróżne`,
  total_voyageur: `Razem podróżujący`,
  net_h_te: `Host sieciowy`,
  avantage_fiscal___pro: `Korzyści podatkowe i korzyści`,
  consultez_votre_expert_comptable_: `Skonsultuj się ze swoim księgowym.`,
  diff_rence_h_te__claire_et_vendeuse: `Różnica w gospodarzu: jasna i sprzedażowa`,
  frais_h_te___an: `Opłaty dla gospodarzy / rok`,
  _conomie_compar_e___booking: `Ekonomiczność w porównaniu do rezerwacji`,
  _conomie_vs_airbnb: `Gospodarka kontra Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Typowy przykład w ciągu 1 roku (gospodarz)`,
  nuits_r_serv_es: `Noce zarezerwowane`,
  s_jours___an: `Pobyty / rok`,
  chiffre_d_affaires_annuel: `Roczny obrót`,
  frais_traveltrok: `Opłaty DONKEY TRAVEL`,
  frais_booking__15__: `Opłaty rezerwacyjne (15%)`,
  frais_airbnb__15_5__: `Opłaty Airbnb (15,5%)`,
  net_h_te_traveltrok: `Host sieciowy DONKEY TRAVEL`,
  comparatif_des_modes: `Porównanie trybów`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `Co aktywujesz zgodnie z użytkowaniem TRAVELTROK.`,
  fonction: `Funkcja`,
  pro: `Zawodowiec`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Utwórz swoje konto i swój sposób użytkowania`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Wybierz, czy zaczynasz jako podróżnik, gospodarz, czy jedno i drugie. Możesz zmienić w dowolnym momencie.`,
  location_simple_c_t__voyageur: `Wynajem pojedynczego po stronie pasażera`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Wyszukiwanie, filtry, szybka rezerwacja i przejrzyste koszty.`,
  gestion_h_te_simplifi_e: `Uproszczone zarządzanie hostami`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Opublikuj swoje zakwaterowanie, zarządzaj kalendarzem i szybko reaguj na prośby.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Ubezpieczenie obejmuje podróżnego i gospodarza.`,
  support_op_rationnel: `Wsparcie operacyjne`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Wsparcie w przypadku sporu, anulowania lub konieczności mediacji.`,
  faq_tarifs: `Często zadawane pytania dotyczące cen`,
  vraiment_0__de_commission_pour_l_h_te__: `Naprawdę 0% prowizji dla gospodarza?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Tak. Gospodarz otrzymuje 100% ustalonej przez siebie ceny. Żadnych opłat za usługę, żadnych opłat manipulacyjnych.`,
  combien_paie_le_voyageur__: `Ile płaci podróżny?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `Podróżny płaci 5% prowizji od kwoty wynajmu. Obejmuje to koszty bieżące, ubezpieczenie i wsparcie.`,
  puis_je__changer_mon_logement_gratuitement__: `Czy mogę bezpłatnie wymienić zakwaterowanie?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Tak ! Jeśli jesteś gospodarzem, możesz wymieniać zakwaterowanie z innymi członkami bez żadnych opłat (0 €).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Dlaczego ten model jest tańszy?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `Pobierając łącznie jedynie 5% (w porównaniu z 15–20% gdzie indziej), sprawiamy, że podróże stają się bardziej dostępne, a jednocześnie lepiej płacimy gospodarzom.`,
  pr_t___activer_ton_mode_traveltrok__: `Gotowy do aktywacji trybu DONKEY TRAVEL?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Podróżnik, gospodarz lub hybryda: zaczyna się od jasnej logiki i kontrolowanych kosztów.`,
  cr_er_mon_compte: `Utwórz moje konto`,
  explorer_les_logements: `Poznaj zakwaterowanie`,
  donn_es_personnelles: `Dane osobowe`,
  politique_de_confidentialit_: `Polityka prywatności`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Dołącz do naszej społeczności i zarezerwuj zakwaterowanie w {{city}}, korzystając z przejrzystych, stałych opłat i ubezpieczenia.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `Europejska platforma wymiany zarezerwowana dla gospodarzy Airbnb`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Prywatny klub dla gości z oceną 4,5+: wyjątkowa subskrypcja umożliwiająca wymianę w całej Europie.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Zarezerwowane dla gospodarzy Airbnb z oceną większą lub równą 4,5.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `50% obniżka w 2026 r.: 25 EUR/rok zamiast 50 EUR/rok. Cena gwarantowana dożywotnio dla pierwszych 1000 rejestracji.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Poza sezonem, przerwy, spotkania gości, wakacyjne oszczędności: wszystko jest przeznaczone dla aktywnych gości w Europie.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Podróżuj taniej (opłaty 5%), gospodarz gratis (0%). Najładniejszy model na rynku.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `Nigdy więcej prowizji w wysokości 15% lub więcej. Dzięki DONKEY TRAVEL gospodarze nie płacą żadnych opłat. Podróżni płacą jedynie 5% opłaty za usługę. To jest uczciwość.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Hipoteza porównawcza: prowizja gospodarza rezerwacji 15% (w zależności od kraju i programu), tryb „tylko gospodarz” Airbnb na poziomie 15,5% po stronie gospodarza i 0 po stronie podróżnego.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `Jeśli prowadzisz firmę, opłata w wysokości 5% może zostać odliczona od Twoich wydatków. Model 0% upraszcza księgowość osobistą.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Dzięki DONKEY TRAVEL możesz obniżyć cenę swoich wypożyczeń i wynajmować częściej. Opłaty Twojego gospodarza pozostają stałe, więc Twoja sieć pozostaje silna.`,
  en_moyenne__c_est_environ___annualhostcase_average: `Średnio roczne oszczędności wynoszą około {{savings}} EUR w porównaniu z platformami opartymi na prowizji.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Założenia: 100EUR za noc, 30EUR sprzątanie, średni czas trwania 3 noce, roczna stawka rezerwacji 50%.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `DONKEY TRAVEL zbiera jedynie dane niezbędne do działania serwisu: konto, profil, giełdy i wsparcie.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Twoje dane są udostępniane wyłącznie niezbędnym usługom technicznym (uwierzytelnianie, hosting, bezpieczeństwo) i nigdy nie są odsprzedawane.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `Możesz poprosić o aktualizację lub usunięcie swoich danych osobowych ze swojego konta lub kontaktując się z pomocą techniczną.`,
  "help.faq.q1.question": "Ile kosztuje subskrypcja?",
  "help.faq.q1.answer":
    "50 €/rok w planie classic. Dostępna jest zniżka startowa 25 €/rok na rok 2026.",
  "help.faq.q2.question":
    "Czy mogę wymienić się bez zachowania tych samych terminów?",
  "help.faq.q2.answer":
    "Absolutnie. Nasz elastyczny system wymiany pozwala gospodarzowi 1 przyjechać do miejsca gospodarza 2 w lipcu, a gospodarz 2 przyjechać do miejsca gospodarza 1 we wrześniu, asynchronicznie.",
  "help.faq.q3.question":
    "Czy strona jest naprawdę zarezerwowana dla gospodarzy z oceną 4,5 i wyższą?",
  "help.faq.q3.answer":
    "Tak. Donkey Travel to zamknięty klub. Po rejestracji sprawdzamy link do Twojego ogłoszenia na Airbnb, aby upewnić się, że Twoja średnia ocen wynosi co najmniej 4,5/5 i że masz opinie.",
  "help.faq.q4.question": "Jak organizowane są wymiany?",
  "help.faq.q4.answer":
    "Nie ma systemu punktowego. Członkowie sami decydują, ile nocy chcą wymienić na podstawie wskazanej przez nich ceny. Ogłoszenie Airbnb służy jako odniesienie, aby sprawdzić, czy propozycja jest uczciwa i wiarygodna.",
  "help.faq.q5.question":
    "Czy są jakieś dodatkowe opłaty (sprzątanie, obsługa)?",
  "help.faq.q5.answer":
    "Nie! Zasada Donkey Travel to w 100% bezpłatna wymiana między gospodarzami. Gospodarz przyjmujący przygotowuje zakwaterowanie, a gość zwraca je w nienagannie czystym stanie (lub ustala warunki sprzątania z gospodarzem zgodnie z ich porozumieniem).",
  "help.faq.q6.question": "Czy mogę powiązać wiele ogłoszeń z Airbnb?",
  "help.faq.q6.answer":
    "Tak, jest to zaplanowane w naszych nadchodzących aktualizacjach, aby umożliwić synchronizację wielu obiektów zakwaterowania i zyskanie jeszcze więcej możliwości wymiany.",
  "help.faq.q7.question": "Co się stanie, jeśli wymiana zostanie anulowana?",
  "help.faq.q7.answer":
    "W przypadku anulowania zapraszamy do komunikacji z gospodarzem za pośrednictwem naszej wewnętrznej poczty, aby znaleźć nowe porozumienie lub nowe daty.",
  "help.faq.q8.question":
    "W jaki sposób gwarantowane jest zaufanie i bezpieczeństwo?",
  "help.faq.q8.answer":
    "Akceptując tylko potwierdzonych gospodarzy (ocena > 4,5), upewniamy się, że wszyscy członkowie wiedzą, co znaczy 'goszczenie'. Dodatkowo, tożsamość i ogłoszenia są weryfikowane przez nasz zespół.",
};
